import SAAFormValidation from '../../components/forms/SAAAttributesFormValidation';

import GroupInfoFormValidation from '@usas/ui-web/components/forms/groups/GroupInfoFormValidation';

const GroupSAAAddValidation = async (formState) => {
  let errors = {
    ...GroupInfoFormValidation(formState),
    ...SAAFormValidation(formState)
  };

  return errors ? errors : {};
};

export default GroupSAAAddValidation;